import type { ResolvedBranchesData } from "@/lib/branchTypes";
import { type MarkdownLineCounts } from "@/app/playbook/timeline/timelineUtils";

// Per-markdown-file line counts, keyed by the relative path stored on each
// node/section. The timeline uses these to map scroll progress back to
// source lines. Shared by PlaybookServer (the real "/" home) and the
// editor's home preview so both derive identical counts.
export function buildMarkdownLineCounts(
  branchData: ResolvedBranchesData
): MarkdownLineCounts {
  const counts: MarkdownLineCounts = {}
  for (const node of Object.values(branchData.nodes)) {
    if (node.markdownFile && node.content?.markdown) {
      counts[node.markdownFile] = node.content.markdown.split("\n").length
    }
    if (node.sections) {
      for (const section of node.sections) {
        if (section.markdownFile && section.content?.markdown) {
          counts[section.markdownFile] = section.content.markdown.split("\n").length
        }
      }
    }
  }
  return counts
}
